import React from 'react';
import Services from '../components/Services/Services';

const ServicesPage = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Services />
    </div>
  );
};

export default ServicesPage;